import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'du-config-overview-empty',
  imports: [TranslatePipe],
  templateUrl: './config-overview-empty.component.html',
  styleUrl: './config-overview-empty.component.scss',
})
export class ConfigOverviewEmptyComponent {}
